


import React, { useState } from 'react';
// FIX: Corrected Firebase User type usage.
import firebase from 'firebase/compat/app';
import { SuggestionIcon, CheckIcon } from './icons';

// ====================================================================================
// ACCIÓN REQUERIDA: Reemplaza esta URL por la URL de tu Web App de Google Apps Script.
// 1. Sigue las instrucciones proporcionadas para crear tu script.
// 2. Despliega el script como "Aplicación web".
// 3. Copia la URL de la aplicación web que se genera y pégala aquí.
// ====================================================================================
const APPS_SCRIPT_WEB_APP_URL = 'https://script.google.com/macros/s/AKfycby7BYgNeQgjNMr9evnXuVGQmqJ34rZcj7DhbkRgz0SVRSQKVRCJbiyDPo3bXEWP3kgO/exec';


interface SuggestionsViewProps {
    sections: string[];
    currentUser: firebase.User | null;
}

const SuggestionsView: React.FC<SuggestionsViewProps> = ({ sections, currentUser }) => {
    const [section, setSection] = useState('');
    const [suggestion, setSuggestion] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!section || !suggestion.trim() || !currentUser || !currentUser.email) {
            setError('Por favor, completa todos los campos para enviar tu sugerencia.');
            return;
        }

        if (APPS_SCRIPT_WEB_APP_URL.includes('REEMPLAZA_ESTO')) {
            setError('Error de configuración: El desarrollador debe configurar la URL de Google Apps Script.');
            console.error('Por favor, actualiza la constante APPS_SCRIPT_WEB_APP_URL en components/SuggestionsView.tsx con tu URL.');
            return;
        }

        setLoading(true);
        setError(null);
        setSuccessMessage(null);

        try {
            // El script de Google Apps espera los datos en un formato específico.
            // Es importante que el `Content-Type` sea `text/plain` para que Apps Script lo reciba correctamente.
            const response = await fetch(APPS_SCRIPT_WEB_APP_URL, {
                method: 'POST',
                mode: 'no-cors', // Para evitar errores de CORS con Apps Script
                headers: {
                    'Content-Type': 'text/plain;charset=utf-8',
                },
                body: JSON.stringify({
                    email: currentUser.email,
                    displayName: currentUser.displayName || 'N/A',
                    section: section,
                    suggestion: suggestion,
                })
            });

            // Con `no-cors`, no podemos leer la respuesta, pero si no hay error de red, asumimos que funcionó.
            setSuccessMessage('¡Sugerencia enviada! Muchas gracias por tu aportación.');
            setSection('');
            setSuggestion('');

        } catch (err) {
            console.error("Error sending suggestion via Apps Script:", err);
            setError('Hubo un problema al enviar tu sugerencia. Por favor, inténtalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-light-surface dark:bg-surface p-6 sm:p-8 rounded-lg border border-light-border dark:border-border shadow-md max-w-3xl mx-auto">
            <div className="text-center mb-8">
                <SuggestionIcon className="w-16 h-16 text-accent-amber mx-auto mb-4" />
                <h1 className="text-3xl font-bold text-light-text-primary dark:text-text-primary">Buzón de Sugerencias</h1>
                <p className="mt-2 text-light-text-secondary dark:text-text-secondary">
                    ¡Tu opinión es muy importante! Nos encanta escuchar tus ideas para mejorar la aplicación.
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label htmlFor="section" className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-1">
                        ¿Sobre qué sección es tu sugerencia?
                    </label>
                    <select
                        id="section"
                        value={section}
                        onChange={(e) => setSection(e.target.value)}
                        required
                        className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                        <option value="" disabled>Selecciona un área...</option>
                        {sections.map(s => <option key={s} value={s}>{s}</option>)}
                        <option value="Otra">Otra</option>
                    </select>
                </div>

                <div>
                    <label htmlFor="suggestion" className="block text-sm font-medium text-light-text-secondary dark:text-text-secondary mb-1">
                        Tu sugerencia
                    </label>
                    <textarea
                        id="suggestion"
                        value={suggestion}
                        onChange={(e) => setSuggestion(e.target.value)}
                        rows={5}
                        required
                        placeholder="Describe tu idea con el mayor detalle posible. ¿Qué problema resuelve? ¿Cómo te imaginas que funcionaría?"
                        className="w-full bg-light-background dark:bg-background border border-light-border dark:border-border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                     <p className="text-xs text-light-text-secondary dark:text-text-secondary mt-1">Por favor, envía una sola idea por sugerencia para que podamos gestionarlas mejor.</p>
                </div>

                {successMessage && (
                    <div className="p-3 rounded-md bg-green-500/10 text-green-700 dark:text-green-300 text-sm flex items-center gap-3">
                        <CheckIcon className="w-5 h-5 flex-shrink-0" />
                        <span>{successMessage}</span>
                    </div>
                )}
                {error && (
                     <div className="p-3 rounded-md bg-red-500/10 text-red-700 dark:text-red-300 text-sm">
                        {error}
                    </div>
                )}

                <div className="text-right">
                    <button
                        type="submit"
                        className="px-6 py-2.5 rounded-lg bg-primary text-white font-semibold hover:bg-blue-600 transition-colors shadow-sm disabled:bg-gray-500 disabled:cursor-wait"
                        disabled={loading || !section || !suggestion.trim()}
                    >
                        {loading ? 'Enviando...' : 'Enviar Sugerencia'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SuggestionsView;